import { Navigate, Route, Routes } from 'react-router-dom';

import AppLayout from './layouts/AppLayout';
import RequireAuth from './components/RequireAuth';
import RequireAdmin from './components/RequireAdmin';
import Login from './pages/Login';
import ChangePassword from './pages/ChangePassword';
import OverviewPage from './pages/Overview';
import BrandsPage from './pages/Brands';
import BrandDetailPage from './pages/BrandDetail';
import ModelsPage from './pages/Models';
import ModelDetailPage from './pages/ModelDetail';
import ComplaintsPage from './pages/Complaints';
import RecallsPage from './pages/Recalls';
import AlertsPage from './pages/Alerts';
import AgentPage from './pages/Agent';
import SocialRiskPage from './pages/SocialRisk';
import DataSourcesPage from './pages/DataSources';
import TasksPage from './pages/Tasks';
import CatalogPage from './pages/Catalog';
import SettingsPage from './pages/Settings';

export default function App() {
  return (
    <Routes>
      {/* public */}
      <Route path="/login" element={<Login />} />

      {/* protected（含 must_change gate by RequireAuth） */}
      <Route element={<RequireAuth />}>
        <Route path="/account/change-password" element={<ChangePassword />} />
        <Route element={<AppLayout />}>
          <Route index element={<Navigate to="/overview" replace />} />
          <Route path="/overview" element={<OverviewPage />} />
          <Route path="/agent" element={<AgentPage />} />
          <Route path="/brands" element={<BrandsPage />} />
          <Route path="/brands/:brandId" element={<BrandDetailPage />} />
          <Route path="/models" element={<ModelsPage />} />
          <Route path="/models/:modelId" element={<ModelDetailPage />} />
          <Route path="/complaints" element={<ComplaintsPage />} />
          <Route path="/recalls" element={<RecallsPage />} />
          <Route path="/alerts" element={<AlertsPage />} />
          {/* PR3-C-2: 社交传播风险（authenticated 非 admin）——在 RequireAuth 内、RequireAdmin 块外 */}
          <Route path="/social-risk" element={<SocialRiskPage />} />
          {/* RBAC: 配置中心 4 路由 admin-only（viewer → redirect /overview + toast） */}
          <Route element={<RequireAdmin />}>
            <Route path="/data-sources" element={<DataSourcesPage />} />
            <Route path="/tasks" element={<TasksPage />} />
            <Route path="/catalog" element={<CatalogPage />} />
            <Route path="/settings" element={<SettingsPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/overview" replace />} />
        </Route>
      </Route>
    </Routes>
  );
}
